import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-news",
  "use": "icon-news-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-news\">\r\n<path d=\"M111.1,34.1V18.5H2v85.7c0,4.3,3.5,7.8,7.8,7.8H115c6.5,0,11.7-5.2,11.7-11.7V34.1H111.1z M103.3,104.2H9.8V26.3h93.5V104.2\r\n\tz M17.6,41.9h77.9v7.8H17.6V41.9z M64.3,57.5h31.2v7.8H64.3V57.5z M64.3,73h31.2v7.8H64.3V73z M64.3,88.6h23.4v7.8H64.3V88.6z\r\n\t M17.6,57.5h39v39h-39V57.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/news.svg
// module id = zgXw
// module chunks = 87